const MESSAGE_NOTIFICATION_SOUND_URL = '/audio/message.wav';
const MIN_PLAY_INTERVAL_MS = 800;

let audio: HTMLAudioElement | null = null;
let lastPlayedAt = 0;

function getMessageNotificationAudio() {
  if (audio) {
    return audio;
  }

  audio = new Audio(MESSAGE_NOTIFICATION_SOUND_URL);
  audio.preload = 'auto';
  return audio;
}

export function playMessageNotificationSound() {
  if (typeof window === 'undefined') {
    return;
  }

  const now = Date.now();
  if (now - lastPlayedAt < MIN_PLAY_INTERVAL_MS) {
    return;
  }
  lastPlayedAt = now;

  const player = getMessageNotificationAudio();
  player.currentTime = 0;
  void player.play().catch(() => undefined);
}
